import { useEffect, useRef } from 'react';
import { getRedirectPath } from '../../../../../shared/utils/function';
import { getLocalItem } from '../../../../../shared/utils/config/localStorage';

/**
 * Outgoing /call routes require a valid Matrix room with a resolvable callee.
 * After logout/login or browser history back, a stale ?roomId= can mount CallingScreen
 * before Redux room metadata exists — redirect home instead of auto-placing or showing errors.
 */
export function useCallRouteEntryGuard({
  navigate,
  roomId,
  shouldAutoPlaceCall,
  hasRoomsLoaded,
  matrixLoading,
  roomMetadata,
  targetSubscriberId,
  activeCall,
}) {
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (hasRedirectedRef.current) return;
    if (!shouldAutoPlaceCall) return;
    if (activeCall) return;

    const redirectHome = () => {
      hasRedirectedRef.current = true;
      const path = getRedirectPath(getLocalItem('role'));
      navigate.to(path, { replace: true });
    };

    if (!roomId) {
      redirectHome();
      return;
    }

    if (!hasRoomsLoaded || matrixLoading) return;

    if (!roomMetadata || !targetSubscriberId) {
      redirectHome();
    }
  }, [
    navigate,
    roomId,
    shouldAutoPlaceCall,
    hasRoomsLoaded,
    matrixLoading,
    roomMetadata,
    targetSubscriberId,
    activeCall,
  ]);
}
